import { FC } from "react";
import {
  Button,
  Button as TaltechButton,
  BUTTON_COLOR,
  ICONS,
} from "taltech-styleguide";
export const PreviousBtn: FC<any> = ({ ...props }) => {
  return (
    <>
      <div className={"d-flex justify-content-center"}>
        <Button
          className={"w-100 mr-4"}
          {...props}
          variant={BUTTON_COLOR.OUTLINE_PRIMARY}
          iconLeft={ICONS.ARROW_OPEN_LEFT}
          size="sm"
        >
          PREVIOUS
        </Button>
      </div>
    </>
  );
};

export const NextBtn: FC<any> = ({ ...props }) => {
  return (
    <>
      <div className={"d-flex justify-content-center"}>
        <TaltechButton
          className={"w-100 mr-4"}
          {...props}
          variant={BUTTON_COLOR.SECONDARY}
          iconRight={ICONS.ARROW_OPEN_RIGHT}
          size="sm"
        >
          NEXT
        </TaltechButton>
      </div>
    </>
  );
};

export const SubmitBtn: FC<any> = ({ ...props }) => {
  return (
    <>
      <div className={"d-flex justify-content-center"}>
        <TaltechButton
          className={"w-100 mr-4"}
          {...props}
          variant={BUTTON_COLOR.SECONDARY}
          iconRight={ICONS.SUCCESS}
          size="sm"
        >
          SUBMIT
        </TaltechButton>
      </div>
    </>
  );
};

export const CancelBtn: FC<any> = ({ ...props }) => {
  return (
    <>
      <div className={"d-flex justify-content-center"}>
        <TaltechButton
          className={"w-100 mr-4"}
          {...props}
          variant={BUTTON_COLOR.OUTLINE_PRIMARY}
          iconRight={ICONS.CROSS}
          size="sm"
        >
          CANCEL
        </TaltechButton>
      </div>
    </>
  );
};
